var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClinic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.166 15.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aa{fill:#fff;}.bb{fill:none;stroke:#205072;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19 -150)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1278.285 -636.575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1297.285 786.575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1303.369,802.5a.442.442,0,0,1-.273-.093c-.237-.185-5.811-4.579-5.811-9.749a6.083,6.083,0,0,1,12.166,0c0,5.17-5.572,9.564-5.81,9.749A.44.44,0,0,1,1303.369,802.5Zm0-15.037a5.2,5.2,0,0,0-5.2,5.195c0,4.113,4.089,7.879,5.2,8.822,1.106-.943,5.194-4.709,5.194-8.822A5.2,5.2,0,0,0,1303.369,787.463Z",
    transform: "translate(-1297.285 -786.575)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1302.115 795.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1302.722,796.243",
    transform: "translate(-1302.722 -796.243)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1302.115 791.404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1302.722,792.011",
    transform: "translate(-1302.722 -792.011)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1302.925 790.961)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1304.077,796.158a.443.443,0,0,1-.444-.444v-3.758a.444.444,0,0,1,.888,0v3.758A.444.444,0,0,1,1304.077,796.158Z",
    transform: "translate(-1303.633 -791.512)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1301.045 792.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1305.72,794.515h-3.759a.444.444,0,1,1,0-.888h3.759a.444.444,0,1,1,0,.888Z",
    transform: "translate(-1301.517 -793.627)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.b5eee304.svg";
export { ForwardRef as ReactComponent };